import type { PrincipleLevel } from "@/schemas/Principle";
import { Box, type BoxProps } from "@mui/material";
import { yellow, orange, red } from "@mui/material/colors";

const IMPACT_CONFIG: Record<string, { height: string; color: string }> = {
	baixo: { height: "33%", color: yellow[600] },
	intermediario: { height: "66%", color: orange[600] },
	alto: { height: "100%", color: red[700] },
};

export function PrincipleImpactIcon({ level }: { level: PrincipleLevel }) {
	const config = IMPACT_CONFIG[level];
	if (!config) return null;

	return (
		<Box
			height={config.height}
			width='0.5rem'
			bgcolor={config.color}
			borderRadius='0.375rem'
		/>
	);
}

export function ImpactIcon({ sx, ...rest }: Omit<BoxProps, "children">) {
	return (
		<Box
			sx={{ display: "flex", alignItems: "baseline", gap: "0.125rem", ...sx }}
			{...rest}
		>
			{Object.keys(IMPACT_CONFIG).map((level, index) => {
				const config = IMPACT_CONFIG[level];
				if (!config) return null;

				return (
					<Box
						key={index}
						height={config.height}
						width='0.5rem'
						bgcolor={config.color}
						borderRadius='0.375rem'
					/>
				);
			})}
		</Box>
	);
}
